<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    :width="800"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-model-item
            label="小区名称"
            prop="communityName"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
          >
            <a-input v-model="formData.communityName" :maxLength="50" />
          </a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="省份" prop="provinces">
            <a-select
              v-model="formData.provinces"
              placeholder="请选择省份"
              allow-clear
              @change="handleProvinceChange"
            >
              <a-select-option
                v-for="item in provinceList"
                :value="item.code"
                :key="item.code"
                >{{ item.descript }}({{ item.code }})</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="城市" prop="city">
            <a-select
              v-model="formData.city"
              placeholder="请选择城市"
              allowClear
              @change="handleCityChange"
            >
              <a-select-option
                v-for="item in tmpCityList"
                :value="item.code"
                :key="item.code"
                >{{ item.descript }}({{ item.code }})</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="区域" prop="region">
            <a-select
              v-model="formData.region"
              placeholder="请选择区域"
              allowClear
              @change="handleRegionChange"
            >
              <a-select-option
                v-for="item in tmpDistrictList"
                :value="item.code"
                :key="item.code"
                >{{ item.descript }}({{ item.code }})</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="商圈" prop="busiCircle">
            <a-select
              v-model="formData.busiCircle"
              placeholder="请选择商圈"
              allowClear
            >
              <a-select-option
                v-for="item in circleList"
                :value="item.code"
                :key="item.code"
                >{{ item.descript }}({{ item.code }})</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="经度" prop="longitude"
            ><a-input v-model="formData.longitude"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="纬度" prop="latitude"
            ><a-input v-model="formData.latitude"
          /></a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item
            class="default"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
            label="地理位置"
            prop="position"
          >
            <a-input v-model="formData.position" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item
            class="default"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
            label="描述"
            prop="content"
          >
            <a-input v-model="formData.content" type="textarea" />
          </a-form-model-item>
        </a-col>
        <!-- <a-col :span="12">
          <a-form-model-item
            label="是否停用"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.sta == 'T' ? true : false"
              @change="onChange('sta')"
            />
          </a-form-model-item>
        </a-col> -->
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "CommunityInfo",
  props: {
    provinceList: {
      type: Array,
      default() {
        return [];
      }
    },
    cityList: {
      type: Array,
      default() {
        return [];
      }
    },
    districtList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      confirmLoading: false,
      tmpCityList: [],
      tmpDistrictList: [],
      circleList: [],
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        communityCode: "",
        communityName: "",
        provinces: "",
        city: "",
        region: "",
        busiCircle: "",
        longitude: "",
        latitude: "",
        content: "",
        position: "",
        sta: "F"
      },
      //form rules
      rules: {
        communityName: [
          {
            required: true,
            message: "请输入小区名称",
            trigger: "change"
          }
        ],
        provinces: [
          {
            required: true,
            message: "请选择省份",
            trigger: "change"
          }
        ],
        city: [
          {
            required: true,
            message: "请选择城市",
            trigger: "change"
          }
        ],
        region: [
          {
            required: true,
            message: "请选择区域",
            trigger: "change"
          }
        ],
        busiCircle: [
          {
            required: true,
            message: "请选择商圈",
            trigger: "change"
          }
        ],
        longitude: [
          {
            required: true,
            message: "请输入经度",
            trigger: "change"
          }
        ],
        latitude: [
          {
            required: true,
            message: "请输入纬度",
            trigger: "change"
          }
        ],
        position: [
          {
            required: true,
            message: "请输入地理位置",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    showModal(type, data) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加小区" : "编辑小区";
      this.modal.type = type;
      if (data && type == "edit") {
        this.formData = Object.assign({}, data);
        this.handleProvinceChange(data.provinces);
        this.handleCityChange(data.city);
        this.handleRegionChange(data.region);
      }
    },
    onChange(column) {
      if (this.formData[column] == "T") {
        this.formData[column] = "F";
      } else {
        this.formData[column] = "T";
      }
    },
    cancel() {
      this.formData = {
        communityCode: "",
        communityName: "",
        provinces: "",
        city: "",
        region: "",
        busiCircle: "",
        longitude: "",
        latitude: "",
        content: "",
        position: "",
        sta: "F"
      };
      this.confirmLoading = false;
      this.$refs.ruleForm.resetFields();
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          this.confirmLoading = true;
          let action = "saveHouseCommunity";
          if (this.modal.type == "edit") {
            action = "modifyHouseCommunity";
          }
          this.$http.roomBksApi[action](param)
            .then(res => {
              if (res.result == 0) {
                this.cancel();
                this.$emit("success");
                this.$message.success(res.msg);
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    },
    handleProvinceChange(value) {
      let arr = [];
      for (let city of this.cityList) {
        if (city.provinceCode == value) {
          arr.push(city);
        }
      }
      this.tmpCityList = arr;
    },
    handleCityChange(value) {
      let arr = [];
      for (let district of this.districtList) {
        if (district.cityCode == value) {
          arr.push(district);
        }
      }
      this.tmpDistrictList = arr;
    },
    handleRegionChange(value) {
      this.$http.systemBksApi
        .findCodeCircleByDistrictCode({ districtCode: value })
        .then(res => {
          if (res.result == 0) {
            this.circleList = res.resultObject;
          }
        });
    }
  }
};
</script>

<style lang="less">
.default .ant-form-item-label {
  word-break: break-all;
  word-break: normal;
  white-space: pre-wrap;
  line-height: 25px;
}
</style>
